module.exports = {
  "id": "ed76caa8-0bf9-439d-a63e-507fe984c737",
  "gtmIds": [
    "GTM-NP9L4JBS",
    "GTM-T2TNT6",
    "GTM-KKS578WK"
  ],
  "hasInAppVersion": false,
  "group": "moreys",
  "language": "en-US",
  "languages": [
    "en-US"
  ],
  "website": "https://www.pigdog.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}